import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { sortEventTypes } from '../../helpers/bulkSend'

/**
 * Searchable event type picker, sorted A to Z ignoring case (the backend
 * answers in no order). Used by the send wizard and by Scheduled sends.
 */
const EventPicker = ({
    id,
    label = 'Event type',
    eventTypes = [],
    value = '',
    onChange,
    disabled = false,
}) => {
    const options = useMemo(() => sortEventTypes(eventTypes), [eventTypes])
    return (
        <Autocomplete
            id={id}
            size="small"
            options={options}
            value={value || null}
            onChange={(_, picked) => onChange(picked ?? '')}
            autoHighlight
            disabled={disabled}
            loading={!options.length}
            loadingText="Loading event types…"
            noOptionsText="No event type matches"
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder="Search event types"
                />
            )}
        />
    )
}

EventPicker.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    eventTypes: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}

export default EventPicker
